import img1 from '../../images/testimonial/1.png'
import img2 from '../../images/testimonial/2.png'
// import img3 from "../../images/testimonial/3.png";
const testimonial = [
  {
    img: img1,
    name: 'Jose Pierce',
    designation: 'Founder / Teacher',
    title: 'It was a fantastic learning experience.',
    text: [
      "Quite a useful teaching platform. I think this platform might be useful for your studies, I'm recommending that you use it. I used to get a bad reputation as a dim student, but now I'm starting to shine academically. I really hope this application is around for the next generation.",
    ],
    rating: 5,
  },
  {
    img: img2,
    name: 'Randy Powell',
    designation: 'Founder / Teacher',
    title: 'Tremendous knowledge was gained.',
    text: [
      'Both of my children use the app practically daily, and as a result, they have made significant academic progress. I appreciate it.',
    ],
    rating: 4,
  },
]
export default testimonial
